import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This file is a fork of https://github.com/Learus/react-material-ui-carousel
 * module fixed to work with MUI@5-beta. The main change in this file is the
 * import of `withStyles` from `@mui/styles` instead of
 * `@mui/material/styles`. Once the module above is fixed and works with
 * MUI@5-beta, we can remove this file and get back to using the dependency.
 */
import { RA$ } from '@infl-ts/util-fp-ts';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Fade, IconButton, Slide } from '@mui/material';
import { constVoid } from 'fp-ts/function';
import { Children, Component } from 'react';
import { Translation } from 'react-i18next';
import { useSwipeable } from 'react-swipeable';
import { makeStyles } from 'tss-react/mui';
import { Tooltip } from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles()(function (_theme, _params, classes) {
  return {
    root: {
      position: 'relative',
      overflow: 'hidden'
    },
    indicators: {
      width: '100%',
      marginTop: '10px',
      textAlign: 'center'
    },
    indicator: {
      cursor: 'pointer',
      transition: '200ms',
      padding: 0,
      color: '#afafaf',
      '&:hover': {
        color: '#1f1f1f'
      },
      '&:active': {
        color: '#1f1f1f'
      }
    },
    indicatorIcon: {
      fontSize: '15px'
    },
    active: {
      color: '#494949'
    },
    buttonWrapper: _defineProperty({
      position: 'absolute',
      height: '100px',
      backgroundColor: 'transparent',
      top: 'calc(50% - 70px)'
    }, "&:hover ".concat(classes.button), {
      backgroundColor: 'black',
      filter: 'brightness(120%)',
      opacity: '0.4'
    }),
    fullHeightHoverWrapper: {
      height: '100%',
      // This is 100% - indicator height - indicator margin
      top: '0'
    },
    fullHeightHoverButton: {},
    buttonVisible: {
      opacity: '1'
    },
    buttonHidden: {
      opacity: '0'
    },
    button: {
      margin: '0 10px',
      position: 'relative',
      backgroundColor: '#494949',
      top: 'calc(50% - 20px) !important',
      color: 'white',
      fontSize: '30px',
      transition: '200ms',
      cursor: 'pointer',
      '&:hover': {
        opacity: '0.6 !important'
      }
    },
    next: {
      right: 0
    },
    prev: {
      left: 0
    }
  };
});

var sanitizeStyleProps = function sanitizeStyleProps(props) {
  return props !== undefined ? {
    style: props.style !== undefined ? props.style : {},
    className: props.className !== undefined ? props.className : ''
  } : {
    style: {},
    className: ''
  };
};

var sanitizeProps = function sanitizeProps(props) {
  var animation = props.animation !== undefined ? props.animation : 'fade';
  var timeout = props.timeout !== undefined ? props.timeout : animation === 'fade' ? 500 : 200;
  return {
    className: props.className !== undefined ? props.className : '',
    children: props.children ? props.children : [],
    index: props.index !== undefined ? props.index : 0,
    strictIndexing: props.strictIndexing !== undefined ? props.strictIndexing : true,
    autoPlay: props.autoPlay !== undefined ? props.autoPlay : true,
    stopAutoPlayOnHover: props.stopAutoPlayOnHover !== undefined ? props.stopAutoPlayOnHover : true,
    interval: props.interval !== undefined ? props.interval : 4000,
    animation: animation,
    timeout: timeout,
    swipe: props.swipe !== undefined ? props.swipe : true,
    navButtonsAlwaysInvisible: props.navButtonsAlwaysInvisible !== undefined ? props.navButtonsAlwaysInvisible : false,
    navButtonsAlwaysVisible: props.navButtonsAlwaysVisible !== undefined ? props.navButtonsAlwaysVisible : false,
    cycleNavigation: props.cycleNavigation !== undefined ? props.cycleNavigation : true,
    fullHeightHover: props.fullHeightHover !== undefined ? props.fullHeightHover : true,
    navButtonsWrapperProps: sanitizeStyleProps(props.navButtonsWrapperProps),
    navButtonsProps: sanitizeStyleProps(props.navButtonsProps),
    NavButton: props.NavButton,
    NextIcon: props.NextIcon !== undefined ? props.NextIcon : /*#__PURE__*/_jsx(NavigateNextIcon, {}),
    PrevIcon: props.PrevIcon !== undefined ? props.PrevIcon : /*#__PURE__*/_jsx(NavigateBeforeIcon, {}),
    indicators: props.indicators !== undefined ? props.indicators : true,
    indicatorContainerProps: sanitizeStyleProps(props.indicatorContainerProps),
    indicatorIconButtonProps: sanitizeStyleProps(props.indicatorIconButtonProps),
    activeIndicatorIconButtonProps: sanitizeStyleProps(props.activeIndicatorIconButtonProps),
    IndicatorIcon: props.IndicatorIcon,
    onChange: props.onChange !== undefined ? props.onChange : constVoid,
    changeOnFirstRender: props.changeOnFirstRender !== undefined ? props.changeOnFirstRender : false,
    next: props.next !== undefined ? props.next : constVoid,
    prev: props.prev !== undefined ? props.prev : constVoid
  };
};

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);

  var _super = _createSuper(Carousel);

  function Carousel() {
    var _this;

    _classCallCheck(this, Carousel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: 0,
      prevActive: 0,
      displayed: 0
    });

    _defineProperty(_assertThisInitialized(_this), "timer", null);

    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _sanitizeProps = sanitizeProps(this.props),
          index = _sanitizeProps.index,
          changeOnFirstRender = _sanitizeProps.changeOnFirstRender;

      this.setActive(index, undefined, changeOnFirstRender);
      this.start();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps_) {
      var prevProps = sanitizeProps(prevProps_);

      var _sanitizeProps2 = sanitizeProps(this.props),
          autoPlay = _sanitizeProps2.autoPlay,
          interval = _sanitizeProps2.interval,
          children = _sanitizeProps2.children,
          index = _sanitizeProps2.index;

      if (autoPlay !== prevProps.autoPlay || interval !== prevProps.interval) this.reset();
      if ((RA$.isArray(children) || RA$.isArray(prevProps.children)) && !(RA$.isArray(children) && RA$.isArray(prevProps.children) && children.length === prevProps.children.length)) this.setActive(index);
      if (prevProps.index !== index) this.setActive(index);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }, {
    key: "start",
    value: function start() {
      var _sanitizeProps3 = sanitizeProps(this.props),
          autoPlay = _sanitizeProps3.autoPlay,
          interval = _sanitizeProps3.interval;

      if (autoPlay) this.timer = setInterval(this.next.bind(this), interval);
    }
  }, {
    key: "reset",
    value: function reset() {
      var _sanitizeProps4 = sanitizeProps(this.props),
          autoPlay = _sanitizeProps4.autoPlay;

      this.stop();
      if (autoPlay) this.start();
    }
  }, {
    key: "setActive",
    value: function setActive(index) {
      var _this2 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constVoid;
      var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _sanitizeProps5 = sanitizeProps(this.props),
          onChange = _sanitizeProps5.onChange,
          timeout = _sanitizeProps5.timeout,
          children = _sanitizeProps5.children,
          strictIndexing = _sanitizeProps5.strictIndexing; // if index is bigger than the children length, set it to be the last child (if strictIndexing)


      if (RA$.isArray(children)) {
        if (strictIndexing && index > children.length - 1) index = children.length - 1;
        if (strictIndexing && index < 0) index = 0;
      } else {
        index = 0;
      }

      var prevActive = this.state.active;
      this.setState({
        active: index,
        prevActive: prevActive,
        displayed: prevActive
      }, this.reset.bind(this));
      setTimeout(function () {
        _this2.setState({
          displayed: index
        }, function () {
          if (runCallbacks) {
            // Call user defined callbacks
            callback(index, prevActive);
            onChange(index, prevActive);
          }
        });
      }, typeof timeout === 'number' ? timeout : timeout.exit);
    }
  }, {
    key: "next",
    value: function next(event) {
      var _sanitizeProps6 = sanitizeProps(this.props),
          childrenEl = _sanitizeProps6.children,
          next = _sanitizeProps6.next,
          cycleNavigation = _sanitizeProps6.cycleNavigation;

      var children = Children.toArray(childrenEl);
      var nextActive = this.state.active + 1 > children.length - 1 ? cycleNavigation ? 0 : this.state.active : this.state.active + 1;
      this.setActive(nextActive, next);
      if (event) event.stopPropagation();
    }
  }, {
    key: "prev",
    value: function prev(event) {
      var _sanitizeProps7 = sanitizeProps(this.props),
          childrenEl = _sanitizeProps7.children,
          prev = _sanitizeProps7.prev,
          cycleNavigation = _sanitizeProps7.cycleNavigation;

      var children = Children.toArray(childrenEl);
      var nextActive = this.state.active - 1 < 0 ? cycleNavigation ? children.length - 1 : this.state.active : this.state.active - 1;
      this.setActive(nextActive, prev);
      if (event) event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _sanitizeProps8 = sanitizeProps(this.props),
          children = _sanitizeProps8.children,
          className = _sanitizeProps8.className,
          stopAutoPlayOnHover = _sanitizeProps8.stopAutoPlayOnHover,
          animation = _sanitizeProps8.animation,
          timeout = _sanitizeProps8.timeout,
          swipe = _sanitizeProps8.swipe,
          navButtonsAlwaysInvisible = _sanitizeProps8.navButtonsAlwaysInvisible,
          navButtonsAlwaysVisible = _sanitizeProps8.navButtonsAlwaysVisible,
          cycleNavigation = _sanitizeProps8.cycleNavigation,
          fullHeightHover = _sanitizeProps8.fullHeightHover,
          navButtonsProps = _sanitizeProps8.navButtonsProps,
          navButtonsWrapperProps = _sanitizeProps8.navButtonsWrapperProps,
          NavButton = _sanitizeProps8.NavButton,
          NextIcon = _sanitizeProps8.NextIcon,
          PrevIcon = _sanitizeProps8.PrevIcon,
          indicators = _sanitizeProps8.indicators,
          indicatorContainerProps = _sanitizeProps8.indicatorContainerProps,
          indicatorIconButtonProps = _sanitizeProps8.indicatorIconButtonProps,
          activeIndicatorIconButtonProps = _sanitizeProps8.activeIndicatorIconButtonProps,
          IndicatorIcon = _sanitizeProps8.IndicatorIcon;

      var childrenArr = Children.toArray(children);
      var classes = this.props.classes;
      var buttonVisibilityClassValue = "".concat(navButtonsAlwaysVisible ? classes.buttonVisible : classes.buttonHidden);
      var buttonCssClassValue = "".concat(classes.button, " ").concat(buttonVisibilityClassValue, " ").concat(fullHeightHover ? classes.fullHeightHoverButton : '', " ").concat(navButtonsProps.className);
      var buttonWrapperCssClassValue = "".concat(classes.buttonWrapper, " ").concat(fullHeightHover ? classes.fullHeightHoverWrapper : '', " ").concat(navButtonsWrapperProps.className);

      var compareActiveDisplayed = function compareActiveDisplayed() {
        if (_this3.state.active === 0 && _this3.state.prevActive === childrenArr.length - 1) return false;
        if (_this3.state.active === childrenArr.length - 1 && _this3.state.prevActive === 0) return true;
        if (_this3.state.active > _this3.state.prevActive) return true;
        return false;
      };

      var showButton = function showButton() {
        var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        if (cycleNavigation) return true;
        if (next && _this3.state.active + 1 > childrenArr.length - 1) return false;
        if (!next && _this3.state.active - 1 < 0) return false;
        return true;
      };

      return /*#__PURE__*/_jsxs("div", {
        className: "".concat(classes.root, " ").concat(className ? className : ''),
        onMouseOver: function onMouseOver() {
          stopAutoPlayOnHover && _this3.stop();
        },
        onMouseOut: function onMouseOut() {
          stopAutoPlayOnHover && _this3.reset();
        },
        "data-component": "Carousel",
        "data-source-file": "index.tsx",
        children: [Array.isArray(children) ? children.map(function (child, index) {
          return /*#__PURE__*/_jsx(CarouselItem, {
            display: index === _this3.state.displayed ? true : false,
            active: index === _this3.state.active ? true : false,
            isNext: compareActiveDisplayed(),
            child: child,
            animation: animation,
            timeout: timeout,
            swipe: swipe,
            next: _this3.next.bind(_this3),
            prev: _this3.prev.bind(_this3),
            "data-element": "CarouselItem",
            "data-component": "Carousel",
            "data-source-file": "index.tsx"
          }, "carousel-item".concat(index));
        }) : /*#__PURE__*/_jsx(CarouselItem, {
          display: true,
          active: true,
          child: children,
          animation: animation,
          timeout: timeout
        }, "carousel-item0"), !navButtonsAlwaysInvisible && showButton(true) && /*#__PURE__*/_jsx("div", {
          className: "".concat(buttonWrapperCssClassValue, " ").concat(classes.next),
          style: navButtonsWrapperProps.style,
          children: NavButton !== undefined ? NavButton({
            onClick: this.next.bind(this),
            className: buttonCssClassValue,
            style: navButtonsProps.style,
            next: true,
            prev: false
          }) : /*#__PURE__*/_jsx(Translation, {
            children: function children(t) {
              return /*#__PURE__*/_jsx(Tooltip, {
                title: t('Next'),
                children: /*#__PURE__*/_jsx(IconButton, {
                  className: "".concat(buttonCssClassValue),
                  onClick: _this3.next.bind(_this3),
                  "aria-label": "Next",
                  style: navButtonsProps.style,
                  children: NextIcon
                })
              });
            }
          })
        }), !navButtonsAlwaysInvisible && showButton(false) && /*#__PURE__*/_jsx("div", {
          className: "".concat(buttonWrapperCssClassValue, " ").concat(classes.prev),
          style: navButtonsWrapperProps.style,
          children: NavButton !== undefined ? NavButton({
            onClick: this.prev.bind(this),
            className: buttonCssClassValue,
            style: navButtonsProps.style,
            next: false,
            prev: true
          }) : /*#__PURE__*/_jsx(Translation, {
            children: function children(t) {
              return /*#__PURE__*/_jsx(Tooltip, {
                title: t('Previous'),
                children: /*#__PURE__*/_jsx(IconButton, {
                  className: "".concat(buttonCssClassValue),
                  onClick: _this3.prev.bind(_this3),
                  "aria-label": "Previous",
                  style: navButtonsProps.style,
                  children: PrevIcon
                })
              });
            }
          })
        }), indicators ? /*#__PURE__*/_jsx(Indicators, {
          classes: classes,
          length: childrenArr.length,
          active: this.state.active,
          press: this.setActive.bind(this),
          indicatorContainerProps: indicatorContainerProps,
          indicatorIconButtonProps: indicatorIconButtonProps,
          activeIndicatorIconButtonProps: activeIndicatorIconButtonProps,
          IndicatorIcon: IndicatorIcon
        }) : null]
      });
    }
  }]);

  return Carousel;
}(Component);

function CarouselItem(props) {
  var swipeHandlers = useSwipeable({
    onSwipedLeft: function onSwipedLeft() {
      var _props$next;

      return (_props$next = props.next) === null || _props$next === void 0 ? void 0 : _props$next.call(props);
    },
    onSwipedRight: function onSwipedRight() {
      var _props$prev;

      return (_props$prev = props.prev) === null || _props$prev === void 0 ? void 0 : _props$prev.call(props);
    }
  });
  if (!props.swipe) swipeHandlers = {
    ref: constVoid
  };
  return props.display ? /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, swipeHandlers), {}, {
    className: "CarouselItem",
    children: props.animation === 'slide' ? /*#__PURE__*/_jsx(Slide, {
      direction: props.active ? props.isNext ? 'left' : 'right' : props.isNext ? 'right' : 'left',
      "in": props.active,
      timeout: props.timeout,
      children: /*#__PURE__*/_jsx("div", {
        children: props.child
      })
    }) : /*#__PURE__*/_jsx(Fade, {
      "in": props.active,
      timeout: props.timeout,
      children: /*#__PURE__*/_jsx("div", {
        children: props.child
      })
    })
  })) : null;
}

function Indicators(props) {
  var classes = props.classes;
  var IndicatorIcon = props.IndicatorIcon !== undefined ? props.IndicatorIcon : /*#__PURE__*/_jsx(FiberManualRecordIcon, {
    className: classes.indicatorIcon
  });
  var indicators = [];

  var _loop = function _loop(_i) {
    var className = _i === props.active ? "".concat(classes.indicator, " ").concat(props.indicatorIconButtonProps.className, " ").concat(classes.active, " ").concat(props.activeIndicatorIconButtonProps.className) : "".concat(classes.indicator, " ").concat(props.indicatorIconButtonProps.className);
    var style = _i === props.active ? Object.assign({}, props.indicatorIconButtonProps.style, props.activeIndicatorIconButtonProps.style) : props.indicatorIconButtonProps.style;

    var item = /*#__PURE__*/_jsx(IconButton, {
      className: className,
      style: style,
      onClick: function onClick() {
        props.press(_i);
      },
      size: "small",
      children: IndicatorIcon
    }, _i);

    indicators.push(item);
  };

  for (var _i = 0; _i < props.length; _i++) {
    _loop(_i);
  }

  var wrapperStyle = props.indicatorContainerProps !== undefined ? props.indicatorContainerProps.style : undefined;
  var wrapperClassName = props.indicatorContainerProps !== undefined ? props.indicatorContainerProps.className : '';
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(classes.indicators, " ").concat(wrapperClassName),
    style: wrapperStyle,
    "data-component": "Indicators",
    "data-source-file": "index.tsx",
    children: indicators
  });
}

var CarouselWithStyles = function CarouselWithStyles(props) {
  var _useStyles = useStyles(),
      classes = _useStyles.classes;

  return /*#__PURE__*/_jsx(Carousel, _objectSpread(_objectSpread({}, props), {}, {
    classes: classes,
    "data-element": "Carousel",
    "data-component": "CarouselWithStyles",
    "data-source-file": "index.tsx"
  }));
};

export { CarouselWithStyles as Carousel };